export default "__VITE_ASSET__e3637e76__"